import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import AnalyticsManager from '../../../../app/analytics';
import { getMediaPath } from '../../../../app/functions';
import DynamicLink from '../../../../components/dynamic_link';
import './index.scss';
import Analytics from 'app/analytics';

const BannerSlider = ({ data, creativeSlot, promotionName, itemsForLog }) => {
    const deviceState = useSelector((store) => store.state.deviceState);

    const isMobile = (deviceState === 'mobile');


    useEffect(() => {
        AnalyticsManager.logViewBannerSliderHomePage(itemsForLog, creativeSlot, promotionName)
    }, [])

    const linkData = data['link'];
    const imageSource = getMediaPath(isMobile ? data['mobileImage'] : data['image']);

    const handleBannerClick = () =>{
        AnalyticsManager.logSelectPromotionBannerSliderHomepage(itemsForLog, creativeSlot,promotionName)
    };

    return (
        <DynamicLink data={linkData} onClick={handleBannerClick} className="homepage-banner-slider">
            <img
                src={imageSource}
                alt="Homepage Banner"
                className="banner-slider-image"
            />
        </DynamicLink>
    );
};

export default BannerSlider;
